export default {
  locize: {
    projectId: '3a42c03a-947b-4813-bd39-103d18b00927',
    apiKey: '9d30d92b-f174-4611-a3ff-067d44ed121c',
  },
};
